'use client';
import React, {useState, Suspense, useEffect} from "react";
import styles from "../(pages)/redeem/redeem.module.css";
import {BubbleTip, FontIcon} from "@/app/_components";
import SCIcon from "@/app/_components/SCIcon/SCIcon";
import {RedeemPath} from "@/app/(redeem)/RedeemMgr";
import {useRouter} from 'next/navigation';
import {RedeemManager} from "@/Core/Redeem/RedeemManager";

import LoginNetManager from "@/Core/Login/LoginNetManager";
import {API} from "@/app/_api/types/auth";
import {useUserBaseInfo, useUser} from "@/app/context/UserContext";
import UserMgr from "@/Core/UserMgr";
import RouterMgr from "@/Core/RouterMgr";
import Load from "@/app/_components/Load/Load";
import {DriveUtil} from "@/Master/DriveUtil";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import { RedeemNewDialogFC } from "./UI/RedeemNewDialogFC";
import {PrivacyDialogFC} from "@/app/_dialogs/PrivacyDialog/PrivacyDialog";
import {RedeemRecordDialogFC} from "@/app/(redeem)/redeemRecord/RedeemRecordDialogFC";
import {RedeemCashOutDialogFC} from "@/app/(redeem)/redeemCashOut/RedeemCashOutDialogFC";
import {RedeemAccountDialogFC} from "@/app/(redeem)/redeemAccount/RedeemAccountDialogFC";
import {BaseInfo} from "@/Core/Login/types/user";
import {hideForceLoading, showForceLoading} from "@/app/_dialogs/LoadingForceDialog/LoadingForceDialogFC";
import Util from "@/Master/Util";

export default function RedeemUI() {
    // const router = useRouter();
    const [failOpen, setFailOpen] = useState(false);
    const [kycOpen, setKycOpen] = useState(false);
    const [kycFailOpen, setKycFailOpen] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [guide, setGuide] = useState(false);

    const user = useUser();
    const userInfo = user.baseInfo;


    useEffect(() => {
        if (UserMgr.hasTokenOk(user.token)){
            if(Util.isLog) console.log('RedeemUI useEffect')
            // RedeemManager.Instance.InitData();
            updateBaseInfo();
        }
    }, [user.token]);

    const updateBaseInfo = (showLoading: boolean = false) => {
        if(showLoading) showForceLoading()
        LoginNetManager.Instance.UpdateUserBaseInfo((data: BaseInfo) => {
            if(showLoading) hideForceLoading()
        });
    }

    const onRedeem = () => {
        if (!LoginNetManager.Instance.isSignUpOKToLogin) {
            return;
        }
        if (RedeemManager.Instance.isRedeemAccountOk) {
            // RouterMgr.push('/redeemCashOut');//提现帐号页面
            SDialogManagerFC.openDialog(RedeemCashOutDialogFC, {
                fcKey: SDialogManagerFC.getFCKey(RedeemCashOutDialogFC),
                onClose: (isOk: boolean) => {
                }
            })
        } else {
            // RouterMgr.push('/redeemAccount');//去设置提现帐号
            SDialogManagerFC.openDialog(RedeemAccountDialogFC, {
                fcKey: SDialogManagerFC.getFCKey(RedeemAccountDialogFC),
                onClose: (isOk: boolean) => {
                    if (RedeemManager.Instance.isRedeemAccountOk) {
                        // RouterMgr.push('/redeemCashOut');//提现帐号页面
                        SDialogManagerFC.openDialog(RedeemCashOutDialogFC, {
                            fcKey: SDialogManagerFC.getFCKey(RedeemCashOutDialogFC),
                            onClose: (isOk: boolean) => {
                            }
                        })
                    }
                }
            })
        }
    }

    const onRedeemHistory = () => {
        if (!LoginNetManager.Instance.isSignUpOKToLogin) {
            return;
        }
        if (RedeemManager.Instance.isRedeemAccountOk) {
            SDialogManagerFC.openDialog(RedeemRecordDialogFC, {
                fcKey: SDialogManagerFC.getFCKey(RedeemRecordDialogFC),
                onClose: (isOk: boolean) => {
                    updateBaseInfo(true);
                }
            })
        } else {
            // RouterMgr.push('/redeemAccount');//去设置提现帐号
            SDialogManagerFC.openDialog(RedeemAccountDialogFC, {
                fcKey: SDialogManagerFC.getFCKey(RedeemAccountDialogFC),
                onClose: (isOk: boolean) => {
                    if (RedeemManager.Instance.isRedeemAccountOk) {
                        SDialogManagerFC.openDialog(RedeemRecordDialogFC, {
                            fcKey: SDialogManagerFC.getFCKey(RedeemRecordDialogFC),
                            onClose: (isOk: boolean) => {
                                updateBaseInfo(true);
                            }
                        })
                    }
                }
            })
        }
    }
    if (!UserMgr.hasTokenOk(user.token)) return <Load/>
    return (
        <>
            <div className={`${styles.redeem}`}>
                <div className={`${styles.title_box} center`}>
                    <FontIcon icon={'s-safety'} style={{color: '#55FF3E'}}></FontIcon>
                    <span className={styles.title}>CASH REDEMPTION</span>
                    <div className={`btn ${styles.history} center`} onClick={() => {
                        onRedeemHistory();
                    }}>
                        {/*<Link className={`center`} href={RedeemPath.redeemRecord}>*/}
                        <FontIcon icon={`s-wait ${styles.historyIcon}`}></FontIcon>
                        {/*</Link>*/}
                    </div>
                </div>
                {/*{userInfo && JSON.stringify(userInfo)}*/}
                <div className={`${styles.itemCenter}`}>
                    <div className={`${styles.itemCenterMore} center`} >
                        <div style={{position: 'relative'}}>
                            <BubbleTip
                                text1="Sweepstakes Coins must be played at least once before being eligible for redemption as a cash prize. Sweepstakes Coin can be redeemed for 1 USD."
                                text2="Redeem your Sweepstakes Coins winnings to your account. Available to Redeem must be minimum SC {0}."
                                minSweepstakesCoins={50}
                            />
                        </div>
                    </div>

                    <div className={`${styles.item} ${styles.scItem}`}>
                        <div className={`${styles.info}`}>Sweepstakes Coins Balance:</div>
                        <div className={`center ${styles.gold}`}>
                            <SCIcon cls={styles.goldIcon}></SCIcon>
                            <span className={`${styles.val}`}>{DriveUtil.ToDollarString(userInfo.scCount)}</span>
                        </div>
                    </div>

                    <div className={`${styles.item} ${styles.itemTop} ${styles.redeemItem}`}>
                        <div className={`${styles.info}`}>Available to Redeem:</div>
                        <div className={`center ${styles.gold}`}>
                            <SCIcon cls={styles.goldIcon}></SCIcon>
                            <span
                                className={`${styles.val} sc-color`}>{DriveUtil.ToDollarString(userInfo.scAvailableToRedeem)}</span>
                        </div>
                    </div>

                    <div className={`${styles.item} ${styles.itemTop} ${styles.balanceItem}`}>
                        <div className={`${styles.info}`}>UnPlayed Balance:</div>
                        <div className={`center ${styles.gold}`}>
                            <SCIcon cls={styles.goldIcon}></SCIcon>
                            <span
                                className={`${styles.val} err-color`}>{DriveUtil.ToDollarString(userInfo.scUnPlayedBalance)}</span>
                        </div>
                    </div>
                </div>
            </div>

            <button className={`btn ${styles.btn}`} type="submit" onClick={onRedeem}>
                Redeem
            </button>

            {/*<button className={`btn ${styles.btn}`} type="submit" onClick={() => {*/}
            {/*    SDialogManagerFC.openDialog(RedeemNewDialogFC);*/}
            {/*}}>*/}
            {/*    new Dialog*/}
            {/*</button>*/}


            {/*<button className={`btn ${styles.btn}`} type="submit" onClick={() => {*/}
            {/*    SDialogManagerFC.openDialog(RedeemKYCDialogFC);*/}
            {/*}}>*/}
            {/*    KYC*/}
            {/*</button>*/}

            {/*<button className={`btn ${styles.btn}`} type="submit" onClick={() => {*/}
            {/*    SDialogManagerFC.openDialog(RedeemFailDialogFC);*/}
            {/*}}>*/}
            {/*    KYC Fail*/}
            {/*</button>*/}


        </>
    )
}
